module.exports = __webpack_public_path__ + "img/file-question-03.15783fa1.svg";